import { axios } from '@Root/API'

export const get = (studyProgrammeId, sessionStatusId) => {
	return axios.get(`course-session/${studyProgrammeId}/session-status/${sessionStatusId}`)
}
